<h1 mat-dialog-title>
  <span>Upload Files To Community</span>

  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</h1>

<div mat-dialog-content class="content">
  <div class="drop-area" tgridFileDragAndDrop (filesDropped)="addFile($event)">
    <span class="drop-text">
      <span>
        Drag and drop <i>file</i> or <a (click)="fileUpload.click()" tabindex="0" (keyup.enter)="fileUpload.click()">browse</a>
      </span>
    </span>
    <input #fileUpload type="file" (change)="addFile(fileUpload.files)" hidden multiple/>
  </div>

  <!--  Put uploaded files here-->
  @if (files.length) {
    <hr>
      @for (file of files; track file) {
        <div class="file-to-upload">
          <span class="ellipsis">{{file.fileName}}</span>
          <button mat-icon-button (click)="removeFile(file)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      }
    }


    @if (showCommunities) {
      <hr>
        <h4>Select Communitie(s) to upload files to.</h4>
        @for (community of data.communities | async; track community) {
          <mat-checkbox class="ellipsis" (change)="updateSelection($event,community)" style="display: block"
            >
            {{community.displayName}}
          </mat-checkbox>
        }
      }


    </div>

    <div class="actions" mat-dialog-actions>
      <button mat-flat-button color="primary" (click)="uploadFiles()">Upload Files</button>
    </div>
